/**
 * Labstep
 *
 * @desc ShowEdit component for IUPACName
 */

import { fieldName } from 'labstep-web/components/PubChemMetadata/Form/fields';
import { PubChemMetadataFormShowEditGeneric } from 'labstep-web/components/PubChemMetadata/Form/ShowEdit/Generic';
import type React from 'react';
import type { IPubChemMetadataFormShowEditIUPACNameProps } from './types';

export const PubChemMetadataFormShowEditIUPACName: React.FC<
  IPubChemMetadataFormShowEditIUPACNameProps
> = ({ parent, pubChemMetadata }) => (
  <PubChemMetadataFormShowEditGeneric
    pubChemMetadata={pubChemMetadata}
    parent={parent}
    field={fieldName}
  />
);
